// 4 April 2024
// Feature Update
// Added counter tracking feature

const _0x13003e = _0x34bc;
(function(_0x3f4d46, _0x3d0c83) {
    const _0x3795ee = _0x34bc,
        _0x80ef33 = _0x3f4d46();
    while (!![]) {
        try {
            const _0x311aff = -parseInt(_0x3795ee(0xd0)) /
                0x1 * (parseInt(_0x3795ee(0xf5)) / 0x2) + parseInt(_0x3795ee(0x12c)) / 0x3 * (-parseInt(
                    _0x3795ee(0xd9)) / 0x4) + -parseInt(_0x3795ee(0xbd)) / 0x5 * (parseInt(_0x3795ee(
                    0x15c)) / 0x6) + -parseInt(_0x3795ee(0xaa)) / 0x7 * (parseInt(_0x3795ee(0x127)) / 0x8) +
                parseInt(_0x3795ee(0x11d)) / 0x9 * (-parseInt(_0x3795ee(0x11b)) / 0xa) + -parseInt(
                    _0x3795ee(0x150)) / 0xb * (-parseInt(_0x3795ee(0xdb)) / 0xc) + -parseInt(_0x3795ee(
                    0x140)) / 0xd * (-parseInt(_0x3795ee(0x14b)) / 0xe);
            if (_0x311aff === _0x3d0c83) break;
            else _0x80ef33['push'](_0x80ef33['shift']());
        } catch (_0x1b599c) {
            _0x80ef33['push'](
                _0x80ef33['shift']());
        }
    }
}(_0x37b7, 0x4ae93));
var vimeoScript = document[_0x13003e(0x159)](_0x13003e(0xb6));
vimeoScript[_0x13003e(0x147)] = _0x13003e(0x171), vimeoScript['async'] = !![];

function _0x37b7() {
    const _0x4ab198 = ['tagName', 'false', 'muted',
        '{\x22event\x22:\x22command\x22,\x22func\x22:\x22pauseVideo\x22,\x22args\x22:\x22\x22}',
        '10HkYHce', 'floor', '[f-data-video=\x22show-pause\x22]', 'padStart', 'VIDEO', 'data',
        'Player', 'volume', 'f-data-video-autoplay-scroll', 'getQualities', 'PlayerState', 'value',
        'isIntersecting', 'querySelector', '[f-data-video=\x22volume-slider\x22]',
        '[f-data-video-autoplay-scroll]', '[f-data-video=\x22poster\x22]',
        '[f-data-video=\x22replay-button\x22]', 'getAttribute', 'ontouchstart', 'auto',
        'f-data-video-autoplay', 'touchend', 'buffered', 'postMessage', 'IFRAME', 'push', 'getVolume',
        '[f-data-video=\x22loader\x22]',
        'Changing\x20video\x20quality\x20is\x20not\x20enabled\x20for\x20this\x20video.', 'then',
        'iframe', 'getDuration', 'true', '[f-data-video=\x22youtube-element\x22]',
        '[f-data-video=\x22vimeo-player\x22]', 'touchstart', '[f-data-video=\x22progress\x22]',
        '3097370nOTShg', 'f-data-video-shortcut', '9uKnJmG', 'offsetWidth', 'loaded',
        '[f-data-video-speed]', 'ArrowRight', 'pause', 'f-data-video-speed', 'cloneNode', 'post',
        '[f-data-video-loop]', '8xajANo', '[f-data-video-muted]', 'percent',
        'source[f-data-video-src-quality=\x22', 'length', '8031JcibKK', 'vimeo', 'pauseVideo',
        'forEach', '00:00', '[f-data-video=\x22poster-button\x22]', '[f-data-video=\x22title\x22]',
        'fail', 'hide', 'bufferstart', 'key', 'getTextTracks', 'getFullscreen', '.ytp-pause-overlay',
        'ended', 'arrowup', 'label', 'onYouTubeIframeAPIReady',
        'Changing\x20video\x20quality\x20is\x20not\x20supported\x20for\x20YouTube\x20videos.',
        '[f-data-video=\x22speed-text\x22]', '13AYzoFd', 'setQuality', 'touches', 'pageX',
        '[f-data-video=\x22quality-text\x22]', '0px', 'classList', 'src', '[f-data-video-quality]',
        'textContent', 'observe', '24406970Nerplh', 'mouseup', 'play',
        '[f-data-video=\x22duration\x22]', 'width', '4523563OrQeDL', 'getPaused',
        '[f-data-video=\x22caption-lang\x22]', '[f-data-video=\x22pause-icon\x22]', 'arrowdown',
        '[f-data-video=\x22minimize\x22]', 'includes', '[f-data-video=\x22volume-button\x22]',
        '{\x22method\x22:\x22pause\x22}', 'createElement', '[f-data-video=\x22preview-wrapper\x22]',
        'CUED', '48ZVtOJB', 'https://videsigns-staging.co.uk/flowplay-counter', 'offsetHeight',
        '[f-data-video=\x22show-play\x22]', 'PAUSED', '[f-data-video=\x22current-time\x22]',
        'requestFullscreen', 'progress', 'log', 'currentTime', 'documentElement', 'setLoop',
        'contentWindow', 'getVideoTitle', '[f-data-video-autoplay]', 'getPlayerState', 'closest',
        'seekTo', 'f-data-video-controls', '[f-data-video=\x22play-icon\x22]',
        'https://www.youtube.com/player_api', 'https://player.vimeo.com/api/player.js',
        '[f-data-video=\x22caption\x22]', '[f-data-video-caption]', 'keydown', 'input', 'playVideo',
        '[f-data-video=\x22play-button\x22]', 'load', 'left', 'autoplay',
        '[f-data-quality=\x22default\x22]', '[f-data-video=\x22loading\x22]', 'toUpperCase',
        'PLAYING', 'some', 'remove', 'appendChild', 'Failed\x20to\x20update\x20counter:', 'cookie',
        '[f-data-video-preview-offset-left]', 'toLowerCase', 'getCurrentTime', 'currentScript',
        'f-data-video-id', '2676149SQrDJd', '[f-data-video=\x22video-preview\x22]',
        '[f-data-video=\x22video-element\x22]', 'setCurrentTime', 'f-data-video-caption', 'display',
        'split', 'f-data-video-loop', 'setAttribute', 'ArrowLeft', 'f-data-poster-once', 'timeupdate',
        'script', 'querySelectorAll', 'readyState', 'duration', 'mousemove', 'loadedmetadata',
        'disableTextTrack', '197885sSCMJf', 'offsetX', 'BUFFERING', 'toString',
        '[f-data-video=\x22backward-button\x22]', 'exitFullscreen',
        '[f-data-video=\x22forward-button\x22]', 'ArrowUp', '[f-data-video=\x22progress-bar\x22]',
        'Normal', 'none', 'parentNode', 'arrowleft', 'add', '[f-data-video=\x22caption-wrapper\x22]',
        'paused', 'Fullscreen\x20mode\x20is\x20not\x20supported\x20for\x20YouTube\x20videos.',
        'style', 'dispatchEvent', '45212QDjmCk', '[f-data-video=\x22fullscreen\x22]', 'seconds',
        'addEventListener', 'click', 'fullscreenElement', 'f-data-video-preview-offset-left',
        '[f-data-video=\x22vimeo-element\x22]', 'substring', '916TYmfXv', 'error', '12rcJcAZ',
        'getLoop', 'show', 'opacity', 'ArrowDown', 'touchmove', 'preventDefault',
        '[f-data-video=\x22overlay\x22]', 'target', 'insertBefore',
        '[f-data-video=\x22pause-button\x22]', 'end', 'getBoundingClientRect', 'canplaythrough',
        'mousedown', 'loop', 'f-data-video-quality', 'webkitRequestFullscreen',
        'Loop\x20mode\x20is\x20not\x20supported\x20for\x20YouTube\x20videos.',
        '[f-data-video=\x22wrapper\x22]', '[f-data-poster-once]', 'setVolume'
    ];
    _0x37b7 = function() { return _0x4ab198; };
    return _0x37b7();
}

function _0x34bc(_0x586fef, _0x2cd5fc) {
    const _0x37b7ed = _0x37b7();
    return _0x34bc = function(
        _0x34bc2c, _0x2e0821) {
        _0x34bc2c = _0x34bc2c - 0xa1;
        let _0x516cbc = _0x37b7ed[
            _0x34bc2c];
        return _0x516cbc;
    }, _0x34bc(_0x586fef, _0x2cd5fc);
}
var youtubeScript = document[_0x13003e(0x159)](_0x13003e(0xb6));
youtubeScript[_0x13003e(0x147)] = _0x13003e(0x170);
var currentScript = document[_0x13003e(0xa8)];
currentScript[_0x13003e(0xc8)][_0x13003e(0xe4)](vimeoScript, currentScript), currentScript[
    _0x13003e(0xc8)][_0x13003e(0xe4)](youtubeScript, currentScript);

function pauseAllPlayers() {
    const _0x33135b = _0x13003e,
        _0x2c3fb0 = document['querySelectorAll'](_0x33135b(0xee));
    _0x2c3fb0[_0x33135b(0x12f)](_0x596523 => {
            const _0x53438a = _0x33135b;
            let _0x18f8a3 = _0x596523[
                _0x53438a(0x102)]('video,\x20iframe');
            if (_0x18f8a3) {
                if (_0x18f8a3[_0x53438a(0xf1)] ===
                    _0x53438a(0xf9)) _0x18f8a3['pause']();
                else {
                    if (_0x18f8a3['tagName'] === _0x53438a(0x10e)) {
                        const _0x117489 = _0x18f8a3[
                            _0x53438a(0x107)]('src');
                        if (_0x117489) {
                            if (_0x117489[_0x53438a(0x156)](
                                    'youtube')) _0x18f8a3['contentWindow']['postMessage'](_0x53438a(0xf4), '*');
                            else _0x117489[_0x53438a(0x156)](_0x53438a(0x12d)) && _0x18f8a3[_0x53438a(0x168)][
                                _0x53438a(0x10d)
                            ](_0x53438a(0x158), '*');
                        }
                    }
                }
            }
        }), $(_0x33135b(0x16f))[_0x33135b(0xdd)](), $(
            _0x33135b(0x177))[_0x33135b(0xdd)](), $('[f-data-video=\x22pause-icon\x22]')[_0x33135b(0x134)]
        (), $(_0x33135b(0xe5))['hide']();
}
const rangeSlider = new Event('input', { 'bubbles': !![], 'cancelable': !![] });
let currentVideo = null;

function initializeVideoPlayer(_0x51596a) {
    const _0x3e24f1 = _0x13003e,
        _0x1f4838 = _0x51596a['closest'](_0x3e24f1(0xee)),
        _0x11dcf3 = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22poster-button\x22]'),
        _0x24a732 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0xe2)),
        _0x253661 = _0x1f4838['querySelector']('[f-data-video=\x22poster\x22]'),
        _0x27859e = _0x1f4838[_0x3e24f1(0x107)](_0x3e24f1(0x11c)),
        _0x492cd3 = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22play-button\x22]'),
        _0x226e49 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0xe5)),
        _0xba53c2 = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22forward-button\x22]'),
        _0x2a3864 = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22backward-button\x22]'),
        _0x162163 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x106)),
        _0x2956c4 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x153)),
        _0xb1d62c = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22play-icon\x22]'),
        _0x3b755 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x11a)),
        _0x35710a = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22progress-bar\x22]'),
        _0x3005b0 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x17c)),
        _0x50dc03 = _0x1f4838['querySelector']('[f-data-video=\x22fullscreen\x22]'),
        _0x393b6d = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x155)),
        _0x2f9599 = _0x1f4838['querySelector']('[f-data-video=\x22current-time\x22]'),
        _0x31abdc = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x14e)),
        _0x179595 = _0x1f4838['querySelector'](_0x3e24f1(0x103)),
        _0x187fc6 = _0x1f4838['querySelector']('[f-data-video=\x22volume-button\x22]'),
        _0x495c07 = _0x1f4838[_0x3e24f1(0xb7)](_0x3e24f1(0x120)),
        _0x35a39d = _0x1f4838[_0x3e24f1(0xb7)](_0x3e24f1(0x148)),
        _0x2edf1f = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x17b)),
        _0x5d1eea = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0xab)),
        _0x14cb83 = _0x1f4838['querySelector'](_0x3e24f1(0x144)),
        _0x541344 = _0x1f4838['querySelector']('[f-data-video=\x22speed-text\x22]'),
        _0x112469 = _0x1f4838[_0x3e24f1(0x102)](_0x3e24f1(0x15a)),
        _0x57338c = _0x1f4838[_0x3e24f1(0x102)]('[f-data-poster-once]') ? _0x1f4838[_0x3e24f1(0x102)](
            _0x3e24f1(0xef))[_0x3e24f1(0x107)](_0x3e24f1(0xb4)) : ![],
        _0x453b0b = _0x1f4838[_0x3e24f1(0x102)]('[f-data-video=\x22loader\x22]'),
        _0x468324 = _0x1f4838[_0x3e24f1(0xb7)](_0x3e24f1(0xf7)),
        _0x84bb2f = _0x1f4838['querySelectorAll'](_0x3e24f1(0x15f));
    let _0xdd69f0 = 0x0,
        _0x53df3b = 0x0;
    const _0x228848 = 0xa,
        _0x39a77e = 0xa;
    let _0x23f242 = 0x0,
        _0x385fe0 = ![],
        _0x3663dc = ![],
        _0x3312ef = ![];
    const _0x5c4021 = _0x1f4838['querySelector'](_0x3e24f1(0xa5)) ? Number(
        _0x1f4838[_0x3e24f1(0x102)]('[f-data-video-preview-offset-left]')[_0x3e24f1(0x107)](_0x3e24f1(
            0xd6))) : '';

    function _0x5b8132(_0x1e792d) {
        const _0x9daac9 = _0x3e24f1,
            _0x1e315f = Math[_0x9daac9(0xf6)](_0x1e792d / 0x3c)[_0x9daac9(0xc0)]()[_0x9daac9(0xf8)](0x2,
                '0'),
            _0x4a8a68 = Math[_0x9daac9(0xf6)](_0x1e792d % 0x3c)[_0x9daac9(0xc0)]()[_0x9daac9(0xf8)](0x2,
                '0');
        return _0x1e315f + ':' + _0x4a8a68;
    }

    function _0x3fcd79() {
        const _0xb6c09 = _0x3e24f1;
        _0x492cd3 && (_0x492cd3[_0xb6c09(0xce)]['display'] = _0xb6c09(0xc7)), _0xb1d62c && (_0xb1d62c[
                _0xb6c09(0xce)][_0xb6c09(0xaf)] = _0xb6c09(0xc7)), _0x2956c4 && (_0x2956c4[_0xb6c09(0xce)][
                _0xb6c09(0xaf)
            ] = ''), _0x226e49 && (_0x226e49[_0xb6c09(0xce)][_0xb6c09(0xaf)] = ''), _0x162163 && (
                _0x162163[_0xb6c09(0xce)]['display'] = 'none'), _0x253661 && (_0x57338c === _0xb6c09(
                0x116) ? !_0x3663dc && (_0x253661[_0xb6c09(0xce)][_0xb6c09(0xaf)] = _0xb6c09(0xc7),
                _0x3663dc = !![]) : _0x253661[_0xb6c09(0xce)][_0xb6c09(0xaf)] = _0xb6c09(0xc7)),
            _0x468324[_0xb6c09(0x12f)](_0x2d20c5 => {
                const _0x4e664e = _0xb6c09;
                _0x2d20c5['classList'][_0x4e664e(0xa1)](_0x4e664e(0xdd)), _0x2d20c5[_0x4e664e(0x146)][
                    _0x4e664e(0xca)
                ](_0x4e664e(0x134));
            }), _0x84bb2f['forEach'](_0x587202 => {
                const _0x49e938 = _0xb6c09;
                _0x587202[_0x49e938(0x146)][_0x49e938(0xca)](_0x49e938(0xdd)), _0x587202[_0x49e938(0x146)]
                    [_0x49e938(0xa1)]('hide');
            });
    }

    function _0x1fb2fd() {
        const _0x54f7f2 = _0x3e24f1;
        _0x2956c4 && (_0x2956c4['style']['display'] = _0x54f7f2(0xc7)), _0x226e49 && (_0x226e49[
                _0x54f7f2(0xce)][_0x54f7f2(0xaf)] = 'none'), _0x393b6d && (_0x393b6d[_0x54f7f2(0xce)][
                _0x54f7f2(0xaf)
            ] = _0x54f7f2(0xc7)), _0x162163 && (_0x162163[_0x54f7f2(0xce)][_0x54f7f2(0xaf)] = _0x54f7f2(
                0xc7)), _0x31abdc && (_0x31abdc['textContent'] = _0x5b8132(_0x51596a[_0x54f7f2(0xb9)])),
            _0x112469 && (_0x112469[_0x54f7f2(0xce)][_0x54f7f2(0xde)] = 0x0), _0x179595 && (_0x53df3b =
                _0x179595 ? _0x179595['value'] : 0x1, _0x51596a[_0x54f7f2(0xfc)] = _0x179595 ? _0x179595[
                    _0x54f7f2(0x100)] : 0x1), _0x453b0b && (_0x453b0b[_0x54f7f2(0xce)][_0x54f7f2(0xaf)] =
                _0x54f7f2(0xc7)), _0x468324[_0x54f7f2(0x12f)](_0x117c03 => {
                const _0x1a0a91 = _0x54f7f2;
                _0x117c03[_0x1a0a91(0x146)]['add'](_0x1a0a91(0xdd)), _0x117c03[_0x1a0a91(0x146)][
                    _0x1a0a91(0xa1)
                ]('hide');
            }), _0x84bb2f[_0x54f7f2(0x12f)](_0x20d633 => {
                const _0x224d0f = _0x54f7f2;
                _0x20d633[_0x224d0f(0x146)][_0x224d0f(0xa1)](_0x224d0f(0xdd)), _0x20d633['classList'][
                    _0x224d0f(0xca)
                ](_0x224d0f(0x134));
            }), _0x51596a['addEventListener'](_0x54f7f2(0xbb), function() {
                const
                    _0x2f06ca = _0x54f7f2;
                !_0x51596a[_0x2f06ca(0xcc)] && _0x51596a[_0x2f06ca(0xb8)] ===
                    0x4 && _0x3fcd79();
            }), _0x51596a[_0x54f7f2(0x17a)] && _0x3fcd79(), _0x51596a['muted'] &&
            (_0x2ad8d4(), _0x53df3b = 0x1);
    }

    function _0x5467af() {
        const _0x2870d5 = _0x3e24f1;
        pauseAllPlayers(), _0x51596a[_0x2870d5(0x14d)](), currentVideo = _0x51596a, _0x3fcd79();
    }

    function _0x5b4f9e() {
        const _0x1b4713 = _0x3e24f1;
        _0x51596a[_0x1b4713(0x122)](), currentVideo = _0x51596a, _0x492cd3 && (_0x492cd3[_0x1b4713(
                0xce)]['display'] = ''), _0xb1d62c && (_0xb1d62c[_0x1b4713(0xce)]['display'] = ''),
            _0x2956c4 && (_0x2956c4[_0x1b4713(0xce)][_0x1b4713(0xaf)] = _0x1b4713(0xc7)), _0x226e49 && (
                _0x226e49['style'][_0x1b4713(0xaf)] = _0x1b4713(0xc7)), _0x253661 && (_0x57338c ? !
                _0x3663dc && (_0x253661[_0x1b4713(0xce)]['display'] = '') : _0x253661['style'][_0x1b4713(
                    0xaf)] = ''), _0x468324['forEach'](_0xe46cd3 => {
                const _0x120f2d = _0x1b4713;
                _0xe46cd3['classList'][_0x120f2d(0xca)](_0x120f2d(0xdd)), _0xe46cd3['classList'][
                    _0x120f2d(0xa1)
                ](_0x120f2d(0x134));
            }), _0x84bb2f[_0x1b4713(0x12f)](_0x23024a => {
                const _0x252929 =
                    _0x1b4713;
                _0x23024a[_0x252929(0x146)][_0x252929(0xa1)](_0x252929(0xdd)), _0x23024a[_0x252929(0x146)]
                    ['add']('hide');
            });
    }
    _0x51596a[_0x3e24f1(0xd3)]('loadstart', () => {
        const _0x1824d2 =
            _0x3e24f1;
        _0x453b0b && (_0x453b0b[_0x1824d2(0xce)][_0x1824d2(0xaf)] = '');
    }), _0x51596a[
        'addEventListener'](_0x3e24f1(0xe8), () => {
        const _0x5b0bb0 = _0x3e24f1;
        _0x453b0b && (_0x453b0b[_0x5b0bb0(0xce)][_0x5b0bb0(0xaf)] = 'none');
    });

    function _0x124ad3() {
        const _0xcdecf4 = _0x3e24f1;
        _0x51596a[_0xcdecf4(0x165)] += _0x228848;
    }

    function _0x17e968() {
        const _0x4caf14 = _0x3e24f1;
        _0x51596a[_0x4caf14(0x165)] -= _0x39a77e;
    }

    function _0x1e4ddb() {
        const _0x12e48f = _0x3e24f1;
        if (!document[_0x12e48f(0xd5)]) {
            if (
                _0x51596a[_0x12e48f(0x162)]) _0x51596a[_0x12e48f(0x162)]();
            else {
                if (_0x51596a['mozRequestFullScreen']) _0x51596a['mozRequestFullScreen']();
                else _0x51596a['webkitRequestFullscreen'] && _0x51596a[_0x12e48f(0xec)]();
            }
        } else
            document[_0x12e48f(0xc2)]();
    }

    function _0x2007f3() {
        const _0x4bafa8 = _0x3e24f1;
        _0x51596a[_0x4bafa8(0xcc)] ? _0x5467af() : _0x5b4f9e();
    }

    function _0x2594fb() {
        const _0x299173 = _0x3e24f1;
        _0x51596a[_0x299173(0x165)] = 0x0, _0x5467af();
    }

    function _0x1463a4(_0x5e45cb) {
        const _0x3c2b50 = _0x3e24f1;
        if (_0x51596a[_0x3c2b50(0x10c)][
                _0x3c2b50(0x12b)
            ] > 0x0) {
            const _0x1f7558 = _0x5e45cb[_0x3c2b50(0xe3)][_0x3c2b50(0x10c)][_0x3c2b50(0xe6)](
                    _0x5e45cb['target'][_0x3c2b50(0x10c)]['length'] - 0x1),
                _0x19dd21 = _0x1f7558 / _0x51596a[_0x3c2b50(0xb9)] * 0x64;
            _0x3005b0 && (_0x3005b0[_0x3c2b50(0xce)][_0x3c2b50(0x14f)] = _0x19dd21 + '%');
        }
    }

    function _0x3ad4a4(_0x1fce49) {
        const _0x53514f = _0x3e24f1,
            _0x1ace88 = _0x1fce49[_0x53514f(0x143)] - _0x35710a[_0x53514f(0xe7)]()[_0x53514f(0x179)],
            _0x587ab7 = _0x1ace88 * _0x51596a[_0x53514f(0xb9)] / _0x35710a[_0x53514f(0x11e)];
        _0x51596a[_0x53514f(0x165)] = _0x587ab7, _0x85f6e3();
    }
    if (_0x35710a) {
        _0x385fe0 = ![];
        let
            _0x84f5ac = ![];
        const _0x11031b = 0x32;

        function _0x4c139c(_0x159e67, _0x2d4c6f) {
            !_0x84f5ac && (_0x159e67(), _0x84f5ac = !![],
                setTimeout(() => { _0x84f5ac = ![]; }, _0x2d4c6f));
        }

        function _0x210a01(_0x1c9ebd) {
            _0x1c9ebd['preventDefault'](), _0x385fe0 = !![];
            const
                _0x1cc9bd = _0x54ea04 ? _0x1c9ebd['touches'][0x0] : _0x1c9ebd;
            _0x3ad4a4(_0x1cc9bd);
        }

        function _0x10c0f5(_0x4aa193) {
            const _0xf39c90 = _0x3e24f1;
            _0x4aa193[_0xf39c90(0xe1)]();
            if (_0x385fe0) {
                const _0x14579d = _0x54ea04 ? _0x4aa193[
                    'touches'][0x0] : _0x4aa193;
                _0x3ad4a4(_0x14579d);
            }
        }

        function _0x94d904() { _0x385fe0 = ![]; }
        const _0x54ea04 = _0x3e24f1(0x108) in document[
            _0x3e24f1(0x166)];
        _0x54ea04 ? (_0x35710a[_0x3e24f1(0xd3)](_0x3e24f1(0x119), _0x210a01), _0x35710a[_0x3e24f1(0xd3)]
            (_0x3e24f1(0xe0), _0x10c0f5), _0x35710a[_0x3e24f1(0xd3)](_0x3e24f1(0x10b), _0x94d904)) : (
            _0x35710a['addEventListener'](_0x3e24f1(0xe9), _0x210a01), _0x1f4838[_0x3e24f1(0xd3)](
                _0x3e24f1(0xba), _0x10c0f5), _0x1f4838[_0x3e24f1(0xd3)](_0x3e24f1(0x14c), _0x94d904));
    }

    function _0x2b231e(_0x15eda2) {
        const _0x33cb4d = _0x3e24f1;
        _0x51596a['playbackRate'] = _0x15eda2, _0x541344 && (Number(_0x15eda2) === 0x1 ? _0x541344[
            _0x33cb4d(0x149)] = _0x33cb4d(0xc6) : _0x541344['textContent'] = _0x15eda2 + 'x');
    }

    function _0x5e0fff(_0x3ed429) {
        const _0x4d4dea = _0x3e24f1;
        _0x23f242 = _0x51596a[_0x4d4dea(0x165)];
        _0x14cb83 && (_0x14cb83[_0x4d4dea(0x149)] = _0x3ed429);
        var _0x509cb8 = _0x51596a[_0x4d4dea(
            0x102)](_0x4d4dea(0x12a) + _0x3ed429 + '\x22]');
        _0x51596a['src'] = _0x509cb8[_0x4d4dea(0x147)], _0x51596a[_0x4d4dea(0x178)](), _0x51596a[
            _0x4d4dea(0x165)] = _0x23f242;
    }

    function _0x85f6e3() {
        const _0x290d05 = _0x3e24f1;
        _0xdd69f0 = _0x51596a[_0x290d05(0x165)] / _0x51596a[_0x290d05(0xb9)] * 0x64, _0x3b755 && (
                _0x3b755[_0x290d05(0xce)][_0x290d05(0x14f)] = _0xdd69f0 + '%'), _0x2f9599 && (_0x2f9599[
                _0x290d05(0x149)] = _0x5b8132(_0x51596a[_0x290d05(0x165)])), _0x51596a['currentTime'] >=
            _0x51596a[_0x290d05(0xb9)] && (_0x162163 && (_0x162163[_0x290d05(0xce)][_0x290d05(0xaf)] =
                ''), _0x5b4f9e());
    }
    _0x51596a[_0x3e24f1(0xd3)]('loadedmetadata', () => {
        const _0x53b1b9 =
            _0x3e24f1;
        _0x31abdc && (_0x31abdc[_0x53b1b9(0x149)] = _0x5b8132(_0x51596a['duration']));
    });

    function _0x13a609() {
        const _0x3a553c = _0x3e24f1;
        _0x179595 && (_0x51596a[_0x3a553c(0xf3)] && (_0x51596a[_0x3a553c(0xf3)] = ![]), _0x51596a[
            _0x3a553c(0xfc)] = _0x179595[_0x3a553c(0x100)]), _0x214433();
    }

    function _0x2ad8d4() {
        const _0x8dd45b = _0x3e24f1;
        _0x179595 && (_0x51596a[_0x8dd45b(0xfc)] > 0x0 ? (_0x53df3b = _0x51596a['volume'], _0x179595[
            'value'] = 0x0, _0x51596a[_0x8dd45b(0xfc)] = 0x0, _0x187fc6[_0x8dd45b(0xce)][_0x8dd45b(
            0xde)] = 0.5) : (_0x179595[_0x8dd45b(0x100)] = _0x53df3b, _0x51596a['volume'] = _0x53df3b,
            _0x187fc6[_0x8dd45b(0xce)][_0x8dd45b(0xde)] = 0x1, _0x51596a[_0x8dd45b(0xf3)] && (
                _0x51596a['muted'] = ![])));
    }

    function _0x214433() {
        const _0x14b48b = _0x3e24f1;
        _0x179595 && (_0x179595['value'] = _0x51596a['volume'], _0x51596a[_0x14b48b(0xfc)] <= 0x0 ?
            _0x187fc6['style'][_0x14b48b(0xde)] = 0.5 : (_0x53df3b = _0x51596a[_0x14b48b(0xfc)],
                _0x187fc6[_0x14b48b(0xce)][_0x14b48b(0xde)] = 0x1));
    }

    function _0x47ffc3(_0x2ae2c6) {
        const _0x9efe5a = _0x3e24f1;
        if (_0x27859e) {
            const _0x150682 =
                _0x2ae2c6['key'][_0x9efe5a(0xa6)]();
            (_0x150682 === '\x20' || _0x150682 === 'arrowdown' || _0x150682 === _0x9efe5a(0x13b)) &&
            _0x2ae2c6[_0x9efe5a(0xe1)]();
            if (_0x51596a === currentVideo) switch (_0x150682) {
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    {
                        const _0x471c91 = parseInt(_0x150682) * 0xa,
                            _0x532bd1 = _0x471c91 / 0x64 * _0x51596a['duration'];
                        _0x51596a[_0x9efe5a(0x165)] = _0x532bd1;
                        break;
                    }
                case '\x20':
                    _0x51596a['paused'] ? _0x5467af() : _0x5b4f9e();
                    break;
                case 'k':
                    _0x51596a[_0x9efe5a(0xcc)] ? _0x5467af() : _0x5b4f9e();
                    break;
                case _0x9efe5a(0xc9):
                    _0x17e968();
                    break;
                case 'arrowright':
                    _0x124ad3();
                    break;
                case _0x9efe5a(0x13b):
                    _0x51596a[_0x9efe5a(0xfc)] !== 0x1 && (_0x51596a[_0x9efe5a(0xfc)] += 0.1,
                        _0x214433());
                    break;
                case _0x9efe5a(0x154):
                    _0x51596a['volume'] !== 0x0 && (_0x51596a[_0x9efe5a(0xfc)] -= 0.1, _0x214433());
                    break;
                case 'm':
                    _0x51596a[_0x9efe5a(0xf3)] = !_0x51596a[_0x9efe5a(0xf3)];
                    break;
                case 'f':
                    _0x1e4ddb();
                    break;
                case 'l':
                    _0x51596a[_0x9efe5a(0xea)] = !_0x51596a[_0x9efe5a(0xea)];
                    break;
            }
        }
    }

    function _0x40b488(_0x4a17b3) {
        const _0x2b3bc6 = _0x3e24f1;
        if (_0x5d1eea) {
            const _0x2f905d =
                _0x4a17b3[_0x2b3bc6(0x143)] - _0x35710a[_0x2b3bc6(0xe7)]()[_0x2b3bc6(0x179)],
                _0x443ecc = _0x2f905d * _0x51596a[_0x2b3bc6(0xb9)] / _0x35710a[_0x2b3bc6(0x11e)];
            _0x5d1eea[_0x2b3bc6(0x165)] = _0x443ecc;
            const _0x44b510 = _0x35710a[_0x2b3bc6(0x11e)],
                _0x5651a3 = _0x443ecc / _0x51596a[_0x2b3bc6(0xb9)] * _0x44b510 + _0x5c4021;
            _0x112469 && (_0x112469[_0x2b3bc6(0xce)][_0x2b3bc6(0xaf)] = '', _0x112469[_0x2b3bc6(0xce)][
                _0x2b3bc6(0x179)
            ] = _0x5651a3 + 'px', _0x112469[_0x2b3bc6(0xce)][_0x2b3bc6(0xde)] = 0x1);
        }
    }

    function _0x575295() {
        const _0x13b77c = _0x3e24f1;
        _0x5d1eea && (_0x112469[_0x13b77c(0xce)][_0x13b77c(0xaf)] = _0x13b77c(0xc7), _0x112469[
            _0x13b77c(0xce)]['opacity'] = 0x0);
    }
    _0x11dcf3 && _0x11dcf3[_0x3e24f1(0xd3)](_0x3e24f1(0xd4),
            _0x2007f3), _0x492cd3 && _0x492cd3[_0x3e24f1(0xd3)](_0x3e24f1(0xd4), _0x5467af), _0x226e49 &&
        _0x226e49['addEventListener'](_0x3e24f1(0xd4), _0x5b4f9e), _0xba53c2 && _0xba53c2[_0x3e24f1(
            0xd3)](_0x3e24f1(0xd4), _0x124ad3), _0x2a3864 && _0x2a3864[_0x3e24f1(0xd3)]('click',
            _0x17e968), _0x162163 && _0x162163[_0x3e24f1(0xd3)](_0x3e24f1(0xd4), _0x2594fb), _0x50dc03 &&
        _0x50dc03['addEventListener']('click', _0x1e4ddb), _0x35710a && _0x35710a[_0x3e24f1(0xd3)](
            _0x3e24f1(0xd4), _0x3ad4a4), _0x179595 && (_0x179595['addEventListener'](_0x3e24f1(0x175),
            _0x13a609), _0x179595[_0x3e24f1(0xd3)](_0x3e24f1(0xd4), _0x13a609), _0x179595[_0x3e24f1(
            0xd3)]('touchstart', _0x13a609)), _0x35710a && _0x35710a[_0x3e24f1(0xd3)](_0x3e24f1(0xba),
            _0x40b488), _0x35710a && _0x35710a['addEventListener']('mouseout', _0x575295), _0x187fc6 &&
        _0x187fc6[_0x3e24f1(0xd3)](_0x3e24f1(0xd4), _0x2ad8d4), _0x495c07 && _0x495c07[_0x3e24f1(0x12f)]
        (function(_0x2042cf) {
            const _0x248e3a = _0x3e24f1;
            _0x2042cf[_0x248e3a(0xd3)](_0x248e3a(0xd4), function() {
                const _0x2b98c8 = _0x248e3a;
                var
                    _0x572dfd = this['getAttribute'](_0x2b98c8(0x123));
                _0x2b231e(_0x572dfd);
            });
        }), _0x35a39d && _0x35a39d[_0x3e24f1(0x12f)](function(
            _0x39a5ad) {
            const _0x4616e1 = _0x3e24f1;
            _0x39a5ad[_0x4616e1(0xd3)](_0x4616e1(0xd4), function() {
                const _0x1e252c = _0x4616e1;
                var
                    _0x4594b2 = this[_0x1e252c(0x107)]('f-data-video-quality');
                _0x5e0fff(_0x4594b2);
            });
        }), _0x51596a && _0x51596a[_0x3e24f1(0xd3)](_0x3e24f1(0xb5),
            _0x85f6e3), _0x3005b0 && _0x51596a[_0x3e24f1(0xd3)]('progress', _0x1463a4), _0x1fb2fd(),
        _0x2edf1f && _0x5e0fff(_0x2edf1f[_0x3e24f1(0x107)](_0x3e24f1(0xeb))), document[_0x3e24f1(0xd3)](
            _0x3e24f1(0x174), _0x47ffc3);
}
const HTMLvideos = document[_0x13003e(0xb7)](_0x13003e(0xac));
HTMLvideos['forEach'](_0x3e943a => {
    const _0x12c088 = _0x13003e;
    _0x3e943a[_0x12c088(0x16c)]('[f-data-video=\x22wrapper\x22]') && initializeVideoPlayer(
        _0x3e943a);
});
let youtubePlayer;

function initializeYoutubePlayer(_0x40211a) {
    const _0x5e51bc = _0x13003e,
        _0x1a3343 = _0x40211a[_0x5e51bc(0x16c)](_0x5e51bc(0xee)),
        _0x2f9a7d = _0x1a3343['getAttribute'](_0x5e51bc(0x11c)),
        _0x438e01 = _0x1a3343['querySelector'](_0x5e51bc(0x131)),
        _0x20c0dc = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0xe2)),
        _0x2ca765 = _0x1a3343['querySelector'](_0x5e51bc(0x105)),
        _0x2736d9 = _0x1a3343['querySelector'](_0x5e51bc(0x177)),
        _0x588138 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0xe5)),
        _0x4263ad = _0x1a3343[_0x5e51bc(0x102)]('[f-data-video=\x22forward-button\x22]'),
        _0x7607c2 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0xc1)),
        _0x4cb62b = _0x1a3343['querySelector']('[f-data-video=\x22replay-button\x22]'),
        _0x41185f = _0x1a3343[_0x5e51bc(0x102)]('[f-data-video=\x22pause-icon\x22]'),
        _0x5007ae = _0x1a3343[_0x5e51bc(0x102)]('[f-data-video=\x22play-icon\x22]'),
        _0x9a80eb = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x11a)),
        _0x337c31 = _0x1a3343['querySelector'](_0x5e51bc(0xc5)),
        _0x1118bc = _0x1a3343['querySelector'](_0x5e51bc(0xd1)),
        _0x51b672 = _0x1a3343[_0x5e51bc(0x102)]('[f-data-video=\x22minimize\x22]'),
        _0x1f6976 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x161)),
        _0x2c4123 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x14e)),
        _0x27e245 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x103)),
        _0x2fac1a = _0x1a3343['querySelector'](_0x5e51bc(0x157)),
        _0x2bf0cb = _0x1a3343['querySelectorAll'](_0x5e51bc(0x120)),
        _0x32ef3a = _0x1a3343[_0x5e51bc(0xb7)](_0x5e51bc(0x148)),
        _0x2389fe = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x144)),
        _0x4f20dc = _0x1a3343['querySelector'](_0x5e51bc(0x13f)),
        _0x291a0b = _0x1a3343[_0x5e51bc(0x102)]('[f-data-poster-once]') ? _0x1a3343[_0x5e51bc(0x102)](
            _0x5e51bc(0xef))[_0x5e51bc(0x107)](_0x5e51bc(0xb4)) : ![],
        _0x441989 = _0x1a3343['querySelector']('[f-data-video=\x22loader\x22]'),
        _0x2d1caa = _0x1a3343[_0x5e51bc(0xb7)]('[f-data-video=\x22show-pause\x22]'),
        _0x18d188 = _0x1a3343['querySelectorAll'](_0x5e51bc(0x15f)),
        _0xe087ff = _0x40211a[_0x5e51bc(0x107)](_0x5e51bc(0xa9)),
        _0x523df6 = _0x1a3343[_0x5e51bc(0x11e)],
        _0x3af797 = _0x1a3343[_0x5e51bc(0x15e)],
        _0x59bf81 = _0x40211a[_0x5e51bc(0x107)](_0x5e51bc(0x16e)) ? 0x0 : 0x1,
        _0x423e18 = 0x5,
        _0x4951cf = 0x5;
    let _0x13fb04 = 0x0,
        _0x41e50e = 0x0,
        _0x151eef = ![],
        _0x133982 = 0x0,
        _0x234940 = _0x5e51bc(0x109),
        _0x51f330 = 0x1,
        _0x132e12 = 0x64,
        _0x3a7e19 = ![];
    const _0x2e1480 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x128)) ? _0x1a3343[
            _0x5e51bc(0x102)](_0x5e51bc(0x128))[_0x5e51bc(0x107)]('f-data-video-muted') !== _0x5e51bc(
            0xf2) : ![],
        _0x49320f = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x126)) ? _0x1a3343[_0x5e51bc(0x102)](
            _0x5e51bc(0x126))[_0x5e51bc(0x107)](_0x5e51bc(0xb1)) !== _0x5e51bc(0xf2) : ![],
        _0x2bbb20 = _0x1a3343[_0x5e51bc(0x102)](_0x5e51bc(0x16a)),
        _0x1eae75 = _0x2bbb20 ? _0x2bbb20[_0x5e51bc(0x107)](_0x5e51bc(0x10a)) !== _0x5e51bc(0xf2) : ![];
    console[_0x5e51bc(0x164)](_0x2e1480, _0x1eae75);

    function _0x213efc() {
        const _0xea170c = _0x5e51bc,
            _0xbdc93 = new YT[(_0xea170c(0xfb))](
                _0x40211a, {
                    'width': _0x523df6,
                    'height': _0x3af797,
                    'videoId': _0xe087ff,
                    'playerVars': {
                        'autoplay': _0x1eae75 ?
                            0x1 : 0x0,
                        'mute': _0x2e1480 ? 0x1 : 0x0,
                        'loop': _0x49320f ? 0x1 : 0x0,
                        'controls': _0x59bf81,
                        'disablekb': 0x1,
                        'playsinline': 0x1,
                        'cc_load_policy': 0x1,
                        'cc_lang_pref': _0xea170c(
                            0x109
                        ),
                        'rel': 0x0,
                        'showinfo': 0x0,
                        'iv_load_policy': 0x3,
                        'modestbranding': 0x1,
                        'customControls':
                            !![],
                        'noCookie':
                            ![],
                        'enablejsapi': 0x1,
                        'widgetid': 0x1
                    },
                    'events': { 'onReady': _0x24b924, 'onStateChange': _0x29f598 }
                });
        return _0xbdc93;
    }
    const
        _0x4f4fb7 = _0x213efc();

    function _0x5767db() {
        const _0x443dad = _0x5e51bc;
        _0x41185f && (_0x41185f['style'][_0x443dad(0xaf)] = _0x443dad(0xc7)), _0x588138 && (_0x588138[
                _0x443dad(0xce)][_0x443dad(0xaf)] = _0x443dad(0xc7)), _0x51b672 && (_0x51b672[_0x443dad(
                0xce)][_0x443dad(0xaf)] = _0x443dad(0xc7)), _0x4cb62b && (_0x4cb62b[_0x443dad(0xce)][
                _0x443dad(0xaf)
            ] = _0x443dad(0xc7)), _0x27e245 && (_0x41e50e = _0x27e245 ? _0x27e245[_0x443dad(0x100)] : 0x1,
                console[_0x443dad(0x164)](_0x27e245 ? _0x27e245[_0x443dad(0x100)] * 0x64 : 0x64)),
            _0x2e52bd(0x1), _0x441989 && (_0x441989[_0x443dad(0xce)][_0x443dad(0xaf)] = _0x443dad(0xc7)),
            _0x2d1caa[_0x443dad(0x12f)](_0x2fb05f => {
                const _0x17eb40 = _0x443dad;
                _0x2fb05f[_0x17eb40(0x146)][_0x17eb40(0xca)](_0x17eb40(0xdd)), _0x2fb05f[_0x17eb40(0x146)]
                    [_0x17eb40(0xa1)](_0x17eb40(0x134));
            }), _0x18d188['forEach'](_0x5a6065 => {
                const
                    _0x1489f1 = _0x443dad;
                _0x5a6065[_0x1489f1(0x146)][_0x1489f1(0xa1)](_0x1489f1(0xdd)), _0x5a6065['classList'][
                    _0x1489f1(0xca)
                ](_0x1489f1(0x134));
            }), _0x2e1480 && (_0x2fac1a && (_0x2fac1a[_0x443dad(0xce)][_0x443dad(
                0xde)] = 0.5), _0x27e245 && (_0x27e245[_0x443dad(0x100)] = 0x0), _0x41e50e = 0x1);
    }

    function _0x5c5d85(_0x8e4f72) {
        const _0x5ca0fe = _0x5e51bc,
            _0x5cf44c = Math[_0x5ca0fe(0xf6)](_0x8e4f72 / 0x3c)[_0x5ca0fe(0xc0)]()[_0x5ca0fe(0xf8)](0x2,
                '0'),
            _0x34601e = Math[_0x5ca0fe(0xf6)](_0x8e4f72 % 0x3c)['toString']()[_0x5ca0fe(0xf8)](0x2,
                '0');
        return _0x5cf44c + ':' + _0x34601e;
    }

    function _0x24b924(_0x14eb6c) { _0x5767db(), _0x230ba2(); }

    function _0x230ba2() {
        const _0x366922 = _0x5e51bc;
        _0x133982 = _0x4f4fb7['getDuration'](), _0x2c4123 && (_0x2c4123[_0x366922(0x149)] = _0x5c5d85(
            _0x133982));
    }

    function _0x4a4d24() {
        const _0x297fac = _0x5e51bc;
        _0x2736d9 && (_0x2736d9[_0x297fac(0xce)][_0x297fac(0xaf)] = 'none'), _0x5007ae && (_0x5007ae[
                _0x297fac(0xce)]['display'] = 'none'), _0x41185f && (_0x41185f[_0x297fac(0xce)][_0x297fac(
                0xaf)] = ''), _0x20c0dc && (_0x20c0dc['style']['display'] = ''), _0x588138 && (_0x588138[
                'style'][_0x297fac(0xaf)] = ''), _0x4cb62b && (_0x4cb62b['style']['display'] = _0x297fac(
                0xc7)), _0x2ca765 && (_0x291a0b === 'true' ? !_0x3a7e19 && (_0x2ca765['style'][_0x297fac(
                0xaf)] = 'none', _0x3a7e19 = !![]) : _0x2ca765[_0x297fac(0xce)][_0x297fac(0xaf)] = 'none'),
            _0x2d1caa['forEach'](_0xcc21f1 => {
                const _0x40bca4 = _0x297fac;
                _0xcc21f1[_0x40bca4(0x146)][_0x40bca4(0xa1)]('show'), _0xcc21f1['classList'][_0x40bca4(
                    0xca)]('hide');
            }), _0x18d188[_0x297fac(0x12f)](_0x1835e3 => {
                const _0x2ecbea =
                    _0x297fac;
                _0x1835e3[_0x2ecbea(0x146)][_0x2ecbea(0xca)](_0x2ecbea(0xdd)), _0x1835e3['classList'][
                    _0x2ecbea(0xa1)
                ](_0x2ecbea(0x134));
            });
    }

    function _0x24ded1() {
        const _0x1a7d9a = _0x5e51bc;
        _0x2736d9 && (_0x2736d9['style']['display'] = ''), _0x5007ae && (_0x5007ae[_0x1a7d9a(0xce)][
            _0x1a7d9a(0xaf)
        ] = ''), _0x41185f && (_0x41185f[_0x1a7d9a(0xce)][_0x1a7d9a(0xaf)] = 'none'), _0x588138 && (
            _0x588138[_0x1a7d9a(0xce)][_0x1a7d9a(0xaf)] = _0x1a7d9a(0xc7)), _0x2ca765 && (_0x291a0b ? !
            _0x3a7e19 && (_0x2ca765[_0x1a7d9a(0xce)][_0x1a7d9a(0xaf)] = '') : _0x2ca765['style'][
                _0x1a7d9a(0xaf)
            ] = ''), _0x2d1caa[_0x1a7d9a(0x12f)](_0x21e5f3 => {
            const _0x43dbf2 = _0x1a7d9a;
            _0x21e5f3[_0x43dbf2(0x146)][_0x43dbf2(0xca)]('show'), _0x21e5f3[_0x43dbf2(0x146)][
                _0x43dbf2(0xa1)
            ](_0x43dbf2(0x134));
        }), _0x18d188[_0x1a7d9a(0x12f)](_0x507dd8 => {
            const _0x5bec14 =
                _0x1a7d9a;
            _0x507dd8[_0x5bec14(0x146)][_0x5bec14(0xa1)]('show'), _0x507dd8['classList'][_0x5bec14(
                0xca)](_0x5bec14(0x134));
        });
    }

    function _0x2f343e() {
        const _0x3f9284 = _0x5e51bc;
        pauseAllPlayers(), _0x4f4fb7[_0x3f9284(0x176)](), $(_0x3f9284(0x139))[_0x3f9284(0xa1)]();
    }

    function _0x48b619() {
        const _0x56d600 = _0x5e51bc;
        _0x4f4fb7[_0x56d600(0x12e)]();
    }

    function _0x3744e0() {
        const _0x542419 = _0x5e51bc;
        _0x4f4fb7[_0x542419(0x16d)](_0x13fb04 + _0x423e18, !![]);
    }

    function _0x40c807() { _0x4f4fb7['seekTo'](_0x13fb04 - _0x4951cf, !![]); }

    function _0x1e7073() {
        const _0x52de98 = _0x5e51bc;
        _0x13fb04 = _0x4f4fb7[_0x52de98(0xa7)]() + 0x1;
        _0x1f6976 && (_0x1f6976[_0x52de98(0x149)] = _0x5c5d85(_0x13fb04));
        _0x2c4123 && (_0x2c4123[_0x52de98(0x149)] = _0x5c5d85(_0x133982));
        const _0x363249 = _0x13fb04 /
            _0x133982 * 0x64;
        _0x9a80eb && (_0x9a80eb[_0x52de98(0xce)][_0x52de98(0x14f)] = _0x363249 + '%');
    }

    function _0x1f1e67(_0x38eb03) {
        const _0x595637 = _0x5e51bc,
            _0x32c23b = _0x4f4fb7[_0x595637(0x16b)]();
        if (_0x32c23b === YT[_0x595637(0xff)][_0x595637(
                0x17e)]) _0x48b619();
        else(_0x32c23b === YT[_0x595637(0xff)][_0x595637(0x160)] || _0x32c23b === YT['PlayerState'][
            _0x595637(0x15b)
        ]) && _0x2f343e();
    }

    function _0x346670() {
        const _0x15876b = _0x5e51bc;
        _0x4cb62b && (_0x4cb62b[_0x15876b(0xce)][_0x15876b(0xaf)] = ''), _0x20c0dc && (_0x20c0dc[
            _0x15876b(0xce)]['display'] = 'none'), _0x24ded1(), _0x48b619();
    }

    function _0x3cfe8b(_0x2f26c7) {
        const _0x2b8770 = _0x5e51bc,
            _0x1f725 = _0x337c31['offsetWidth'],
            _0x34e383 = _0x2f26c7[_0x2b8770(0xbe)],
            _0x3c3420 = _0x34e383 / _0x1f725 * 0x64,
            _0x159df9 = _0x3c3420 / 0x64 * _0x133982;
        _0x4f4fb7[_0x2b8770(0x16d)](_0x159df9, !![]), _0x1e7073();
    }
    if (_0x337c31) {
        _0x151eef
            = ![];
        let _0x416b5a = ![];
        const _0x2d2f6e = 0x32;

        function _0x57171d(_0x80f938, _0x5837d0) {
            !_0x416b5a && (_0x80f938(), _0x416b5a = !![],
                setTimeout(() => { _0x416b5a = ![]; }, _0x5837d0));
        }

        function _0x5ccf75(_0x121a59) {
            const _0x12c68c = _0x5e51bc;
            _0x121a59[_0x12c68c(0xe1)](), _0x151eef = !![];
            const _0xdf5ddc = _0x3347b3 ? _0x121a59[
                _0x12c68c(0x142)][0x0] : _0x121a59;
            _0x3cfe8b(_0xdf5ddc);
        }

        function _0x288de3(_0x177f40) {
            const _0x1302b6 = _0x5e51bc;
            _0x177f40[_0x1302b6(0xe1)](), _0x151eef && _0x57171d(() => {
                const _0x363426 = _0x1302b6,
                    _0x2f0c00 = _0x3347b3 ? _0x177f40[_0x363426(0x142)][0x0] : _0x177f40;
                _0x3cfe8b(_0x2f0c00);
            }, _0x2d2f6e);
        }

        function _0x50745a() { _0x151eef = ![]; }
        const _0x3347b3 = _0x5e51bc(0x108) in document[
            _0x5e51bc(0x166)];
        _0x3347b3 ? (_0x337c31[_0x5e51bc(0xd3)](_0x5e51bc(0x119), _0x5ccf75), _0x337c31[_0x5e51bc(0xd3)]
            (_0x5e51bc(0xe0), _0x288de3), _0x337c31[_0x5e51bc(0xd3)](_0x5e51bc(0x10b), _0x50745a)) : (
            _0x337c31['addEventListener'](_0x5e51bc(0xe9), _0x5ccf75), _0x337c31['addEventListener'](
                'mousemove', _0x288de3), _0x337c31[_0x5e51bc(0xd3)](_0x5e51bc(0x14c), _0x50745a));
    }

    function _0xbe5caa() {
        const _0x1698a2 = _0x5e51bc;
        _0x4f4fb7[_0x1698a2(0x16d)](0x0, !![]), _0x2f343e();
    }

    function _0x185158(_0x536829) {
        const _0x403e56 = _0x5e51bc;
        _0x4f4fb7['setPlaybackRate'](Number(_0x536829)), _0x4f20dc && (Number(_0x536829) === 0x1 ?
            _0x4f20dc[_0x403e56(0x149)] = _0x403e56(0xc6) : _0x4f20dc[_0x403e56(0x149)] = _0x536829 +
            'x');
    }

    function _0x201ef8(_0x3fb7d3) {
        const _0x118df3 = _0x5e51bc;
        _0x2389fe && (_0x2389fe[_0x118df3(0x149)] = _0x234940), alert(_0x118df3(0x13e));
    }

    function _0x2e52bd(_0x2bca71) {
        const _0x523b20 = _0x5e51bc;
        _0x2fac1a && (_0x2bca71 < 0.1 ? _0x2fac1a[_0x523b20(0xce)][_0x523b20(0xde)] = 0.5 : _0x2fac1a[
            _0x523b20(0xce)][_0x523b20(0xde)] = 0x1);
    }

    function _0x4040af() {
        const _0x318420 = _0x5e51bc;
        _0x4f4fb7[_0x318420(0xf0)](_0x27e245['value'] * 0x64), _0x2e52bd(_0x27e245[_0x318420(0x100)]);
    }

    function _0x32b3d9() {
        const _0x493d54 = _0x5e51bc;
        _0x132e12 = _0x4f4fb7[_0x493d54(0x110)](), _0x27e245 && (_0x27e245[_0x493d54(0x100)] > 0x0 ? (
            _0x41e50e = _0x27e245[_0x493d54(0x100)], _0x4f4fb7[_0x493d54(0xf0)](0x0), _0x27e245[
                _0x493d54(0x100)] = 0x0, _0x2fac1a[_0x493d54(0xce)][_0x493d54(0xde)] = 0x1) : (
            _0x4f4fb7['setVolume'](_0x41e50e * 0x64), _0x27e245[_0x493d54(0x100)] = _0x41e50e,
            _0x2fac1a[_0x493d54(0xce)][_0x493d54(0xde)] = 0x1, _0x4f4fb7['unMute']()), _0x27e245[
            _0x493d54(0xcf)](rangeSlider));
    }

    function _0x2b5b2a() {
        const _0xe0377 = _0x5e51bc;
        alert(_0xe0377(0xcd));
    }

    function _0x2a05db() {
        alert(
            'Loop\x20mode\x20is\x20not\x20supported\x20for\x20YouTube\x20videos.');
    }

    function _0x2c4a57(_0x66cd29) {
        const _0xf28e84 = _0x5e51bc;
        if (_0x2f9a7d) {
            const _0x542dd6 =
                _0x66cd29[_0xf28e84(0x136)],
                _0x46f497 = _0x27e245[_0xf28e84(0x100)];
            (_0x542dd6 === '\x20' || _0x542dd6 === _0xf28e84(0xdf) || _0x542dd6 === 'ArrowUp') &&
            _0x66cd29[_0xf28e84(0xe1)]();
            if (_0x4f4fb7 === currentVideo) switch (_0x542dd6) {
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    const _0x508ed6 = parseInt(_0x542dd6) * 0xa,
                        _0x59281c = _0x508ed6 / 0x64 * _0x133982;
                    _0x4f4fb7[_0xf28e84(0x16d)](_0x59281c, !![]);
                    break;
                case '\x20':
                case 'k':
                    _0x4f4fb7[_0xf28e84(0x16b)]() === YT[_0xf28e84(0xff)][_0xf28e84(0x160)] ? _0x2f343e() :
                        _0x48b619();
                    break;
                case _0xf28e84(0xb3):
                    _0x40c807();
                    break;
                case _0xf28e84(0x121):
                    _0x3744e0();
                    break;
                case _0xf28e84(0xc4):
                    _0x27e245 && (_0x27e245[_0xf28e84(0x100)] = Number(_0x46f497) + 0.1, _0x4040af());
                    break;
                case 'ArrowDown':
                    _0x27e245 && (_0x27e245['value'] = Number(_0x46f497) - 0.1, _0x4040af());
                    break;
                case 'm':
                    _0x32b3d9();
                    break;
                case 'f':
                    alert('Fullscreen\x20mode\x20is\x20not\x20supported\x20for\x20YouTube\x20videos.');
                    break;
                case 'l':
                    alert(_0xf28e84(0xed));
                    break;
                default:
                    break;
            }
        }
    }
    _0x438e01 && _0x438e01['addEventListener']('click', _0x1f1e67);
    _0x2736d9 && _0x2736d9[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x2f343e);
    _0x588138 && _0x588138[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x48b619);
    _0x4263ad && _0x4263ad[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x3744e0);
    _0x7607c2 && _0x7607c2[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x40c807);
    _0x337c31 && _0x337c31['addEventListener'](_0x5e51bc(0xd4), _0x3cfe8b);
    _0x27e245 && (_0x27e245[_0x5e51bc(0xd3)]('input', _0x4040af), _0x27e245['addEventListener'](
        'touchstart', _0x4040af));
    _0x4cb62b && _0x4cb62b[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0xbe5caa);
    _0x2fac1a && _0x2fac1a[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x32b3d9);
    _0x1118bc && _0x1118bc[_0x5e51bc(0xd3)](_0x5e51bc(0xd4), _0x2b5b2a);
    _0x2bf0cb && _0x2bf0cb[_0x5e51bc(0x12f)](function(_0x54cd0e) {
        const _0x19be68 = _0x5e51bc;
        _0x54cd0e[_0x19be68(0xd3)](_0x19be68(0xd4), function() {
            const _0x5a2b96 = _0x19be68;
            _0x51f330 = this[_0x5a2b96(0x107)](_0x5a2b96(0x123)), _0x185158(_0x51f330);
        });
    });
    _0x32ef3a && _0x32ef3a['forEach'](function(_0x43348b) {
        const _0xc8a051 = _0x5e51bc;
        _0x43348b[_0xc8a051(0xd3)](_0xc8a051(0xd4), function() {
            const _0x3cbdf8 = _0xc8a051;
            _0x234940 = this['getAttribute'](_0x3cbdf8(0xeb)), _0x201ef8(_0x234940);
        });
    });
    document[_0x5e51bc(0xd3)]('keydown', _0x2c4a57);

    function _0x29f598(_0x37e0c6) {
        const _0x5daf14 = _0x5e51bc;
        if (_0x37e0c6[_0x5daf14(0xfa)] ===
            YT[_0x5daf14(0xff)][_0x5daf14(0x17e)]) currentVideo && currentVideo !== _0x4f4fb7 &&
            currentVideo[_0x5daf14(0x12e)](), currentVideo = _0x4f4fb7, _0x4a4d24(), setInterval(
                _0x1e7073, 0x64), _0x441989 && (_0x441989[_0x5daf14(0xce)][_0x5daf14(0xaf)] = 'none');
        else {
            if (_0x37e0c6[_0x5daf14(0xfa)] === YT[_0x5daf14(0xff)][_0x5daf14(0x160)]) _0x24ded1(),
                clearInterval(_0x1e7073);
            else {
                if (_0x37e0c6[_0x5daf14(0xfa)] === YT[_0x5daf14(0xff)]['ENDED']) _0x346670(),
                    _0x48b619(), clearInterval(_0x1e7073);
                else _0x37e0c6[_0x5daf14(0xfa)] === YT[_0x5daf14(0xff)][_0x5daf14(0xbf)] && (_0x441989 && (
                    _0x441989['style'][_0x5daf14(0xaf)] = ''));
            }
        }
    }
    _0x5767db(), _0x213efc();
}
const players = [],
    YTvideos = document[_0x13003e(0xb7)](_0x13003e(0x117));
window[_0x13003e(0x13d)] = function() {
    const _0x2c2d8c = _0x13003e;
    YTvideos[_0x2c2d8c(0x12f)](_0x4f00d4 => {
        const _0x4fed3a = _0x2c2d8c,
            _0x301ea3 = initializeYoutubePlayer(_0x4f00d4);
        players[_0x4fed3a(0x10f)](_0x301ea3);
    });
};

function initializeVimeoPlayer(_0x48cb08) {
    const _0x5784ea = _0x13003e,
        _0x56d2ea = _0x48cb08[_0x5784ea(0x16c)]('[f-data-video=\x22wrapper\x22]'),
        _0x223f88 = _0x56d2ea[_0x5784ea(0x107)](_0x5784ea(0x11c)),
        _0xcc6908 = _0x56d2ea['querySelector'](_0x5784ea(0x118)),
        _0x23ea03 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x131)),
        _0x52d6e0 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0xe2)),
        _0xb4e3fe = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x105)),
        _0x2e10d1 = _0x56d2ea[_0x5784ea(0x102)]('[f-data-video=\x22play-button\x22]'),
        _0x37ac7c = _0x56d2ea['querySelector'](_0x5784ea(0xe5)),
        _0x2d9511 = _0x56d2ea[_0x5784ea(0x102)]('[f-data-video=\x22reset-button\x22]'),
        _0x586138 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0xc3)),
        _0x4b72c9 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0xc1)),
        _0x4bdd87 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x106)),
        _0x491681 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x153)),
        _0x1f6816 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x16f)),
        _0x51671b = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x11a)),
        _0x551af9 = _0x56d2ea['querySelector'](_0x5784ea(0xc5)),
        _0x3a8488 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x17c)),
        _0x583020 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0xd1)),
        _0x1e93ed = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x155)),
        _0x4e41b3 = _0x56d2ea[_0x5784ea(0x102)]('[f-data-video=\x22current-time\x22]'),
        _0x6c6a79 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x14e)),
        _0xd1051 = _0x56d2ea['querySelector'](_0x5784ea(0x103)),
        _0x2832aa = _0x56d2ea['querySelector'](_0x5784ea(0x157)),
        _0x4dcfd7 = _0x56d2ea[_0x5784ea(0xb7)](_0x5784ea(0x132)),
        _0x1ee07b = _0x56d2ea[_0x5784ea(0xb7)]('[f-data-video-speed]'),
        _0x327715 = _0x56d2ea[_0x5784ea(0xb7)]('[f-data-video-quality]'),
        _0x2549a6 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x144)),
        _0x515412 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x13f)),
        _0x4e681c = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x172)),
        _0x4555b = _0x56d2ea[_0x5784ea(0x102)]('[f-data-video=\x22caption-disabled\x22]'),
        _0x1504ad = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x152)),
        _0x23cabc = _0x56d2ea[_0x5784ea(0x102)]('[f-data-poster-once]') ? _0x56d2ea[_0x5784ea(0x102)](
            '[f-data-poster-once]')[_0x5784ea(0x107)](_0x5784ea(0xb4)) : ![],
        _0x57e1d7 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x111)),
        _0xf5a5f8 = _0x56d2ea[_0x5784ea(0xb7)](_0x5784ea(0xf7)),
        _0x2b906f = _0x56d2ea[_0x5784ea(0xb7)]('[f-data-video=\x22show-play\x22]'),
        _0x2bf954 = _0x48cb08['getAttribute']('f-data-video-id'),
        _0x506dd7 = _0x56d2ea['offsetWidth'],
        _0x1cdd13 = _0x56d2ea[_0x5784ea(0x15e)],
        _0x35533b = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x128)) ? _0x56d2ea[_0x5784ea(0x102)](
            _0x5784ea(0x128))['getAttribute']('f-data-video-muted') !== 'false' : ![],
        _0x5cf18d = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x126)) ? _0x56d2ea[_0x5784ea(0x102)](
            _0x5784ea(0x126))[_0x5784ea(0x107)](_0x5784ea(0xb1)) !== 'false' : ![],
        _0x6a9d0 = _0x56d2ea['querySelector']('[f-data-video-autoplay]'),
        _0x3140ee = _0x6a9d0 ? _0x6a9d0['getAttribute']('f-data-video-autoplay') !== _0x5784ea(0xf2) :
        ![],
        _0x4d3131 = _0x56d2ea[_0x5784ea(0x102)](_0x5784ea(0x104)) ? _0x56d2ea[_0x5784ea(0x102)](
            _0x5784ea(0x104))[_0x5784ea(0x107)](_0x5784ea(0xfd)) !== 'false' : ![],
        _0x3b5dd4 = _0x48cb08[_0x5784ea(0x107)](_0x5784ea(0x16e)),
        _0x29c962 = 0x5,
        _0x4d721d = 0x5;
    var _0x1828ff = 0x0;
    let _0x5b9cd3 = ![],
        _0x51f8c2 = 0x1;
    var _0x9179a3 = 0x0,
        _0x1de3bc = 0x0,
        _0x3fc87b = 'auto',
        _0x2afeab = 0x1;
    let _0x4a0718 = ![],
        _0x1b4586 = 'en';
    var
        _0xd9c4a9 = {
            'id': _0x2bf954,
            'width': _0x506dd7,
            'height': _0x1cdd13,
            'controls': _0x3b5dd4,
            'texttrack': 'en',
            'muted': _0x35533b ?
                0x1 : 0x0,
            'loop': _0x5cf18d ? 0x1 : 0x0,
            'autoplay': _0x3140ee ? 0x1 : 0x0,
            'autopause': 0x0
        };
    let _0x11d0c9 = ![];
    var _0x2ca976 = new Vimeo[(_0x5784ea(0xfb))](
        _0x48cb08, _0xd9c4a9);
    const _0x1a85f8 = {
            'root': null,
            'rootMargin': _0x5784ea(
                0x145),
            'threshold': 0.5
        },
        _0x232c2a = new IntersectionObserver(_0x15a16d, _0x1a85f8);

    function _0x15a16d(_0x511787) {
        const _0x125315 = _0x5784ea,
            _0x5ebe09 = _0x511787[0x0];
        _0x5ebe09[_0x125315(0x101)] ? _0x3b021c() : _0x42dbb2();
    }
    _0x4d3131 && _0x232c2a[_0x5784ea(
        0x14a)](_0x48cb08);

    function _0x11173c() {
        const _0xa417d = _0x5784ea;
        _0x2ca976[_0xa417d(0xbc)](), _0xf5a5f8[_0xa417d(0x12f)](_0x480e42 => {
                const _0x2d821a =
                    _0xa417d;
                _0x480e42['classList'][_0x2d821a(0xca)](_0x2d821a(0xdd)), _0x480e42[_0x2d821a(0x146)][
                    _0x2d821a(0xa1)
                ]('hide');
            }), _0x2b906f[_0xa417d(0x12f)](_0x1190b3 => {
                const _0x4c62ff = _0xa417d;
                _0x1190b3[_0x4c62ff(0x146)][_0x4c62ff(0xa1)](_0x4c62ff(0xdd)), _0x1190b3[_0x4c62ff(0x146)]
                    [_0x4c62ff(0xca)](_0x4c62ff(0x134));
            }), _0x491681 && (_0x491681[_0xa417d(0xce)][_0xa417d(
                0xaf)] = 'none'), _0x37ac7c && (_0x37ac7c['style'][_0xa417d(0xaf)] = _0xa417d(0xc7)),
            _0x1e93ed && (_0x1e93ed['style'][_0xa417d(0xaf)] = _0xa417d(0xc7)), _0x4bdd87 && (_0x4bdd87[
                _0xa417d(0xce)][_0xa417d(0xaf)] = _0xa417d(0xc7)), _0x2ca976['volume'] = _0xd1051 ?
            _0xd1051['value'] : 0x1, _0x51f8c2 = _0xd1051 ? _0xd1051['value'] : 0x1, _0x2ca976[_0xa417d(
                0x115)]()[_0xa417d(0x113)](function(_0x4cfe36) {
                const _0xfc4da1 = _0xa417d;
                _0x1828ff = _0x67e36f(_0x4cfe36), _0x9179a3 = _0x4cfe36, _0x6c6a79 && (_0x6c6a79[
                    _0xfc4da1(0x149)] = _0x1828ff);
            }), _0x3140ee && _0x2f6cb3(), _0x35533b && _0x2832aa &&
            _0xd1051 && (_0xd1051[_0xa417d(0x100)] = 0x0, _0x2832aa[_0xa417d(0xce)][_0xa417d(0xde)] = 0.5,
                _0xd1051[_0xa417d(0x100)] = 0x0, _0x51f8c2 = 0x1), _0x57e1d7 && (_0x57e1d7[_0xa417d(0xce)][
                _0xa417d(0xaf)
            ] = _0xa417d(0xc7)), _0x4dcfd7 && _0x2ca976[_0xa417d(0x169)]()['then'](_0x111d88 => {
                const
                    _0x404a35 = _0xa417d;
                _0x4dcfd7[_0x404a35(0x12f)](_0x5ee5b1 => {
                    const _0x4fb0f5 = _0x404a35;
                    _0x5ee5b1[_0x4fb0f5(0x149)] = _0x111d88;
                });
            }), _0x3a8488 && (_0x3a8488['style'][
                _0xa417d(0x14f)
            ] = '0%'), _0x51671b && (_0x3a8488 && (_0x3a8488[_0xa417d(0xce)][_0xa417d(0x14f)] = '0%')),
            _0x4e681c && (_0x4e681c[_0xa417d(0xce)][_0xa417d(0xaf)] = 'none');
    }
    _0x2ca976[_0x5784ea(
        0x137)]()[_0x5784ea(0x113)](function(_0x441f94) {
        const _0x4e79fc = _0x5784ea;
        if (_0x441f94[
                _0x4e79fc(0x12b)] > 0x0) {
            var _0x1ae547 = _0x56d2ea[_0x4e79fc(0x102)](_0x4e79fc(
                    0x173)),
                _0x3a4875 = _0x56d2ea[_0x4e79fc(0x102)](_0x4e79fc(0xcb));
            _0x441f94[_0x4e79fc(0x12f)](function(_0x18ac6a) {
                const _0x128844 = _0x4e79fc;
                if (
                    _0x1ae547) {
                    var _0x2e12f2 = _0x1ae547[_0x128844(0x124)](!![]);
                    _0x2e12f2[_0x128844(0xb2)](_0x128844(0xae), _0x18ac6a['language']), _0x2e12f2[
                        _0x128844(0x149)] = _0x18ac6a[_0x128844(0x13c)], _0x3a4875[_0x128844(0xa2)](
                        _0x2e12f2);
                    let _0x5ac66c = _0x56d2ea['querySelectorAll'](
                        '[f-data-video-caption]');
                    _0x5ac66c['forEach'](_0x463f65 => {
                        _0x463f65['addEventListener']('click',
                            function() {
                                const _0x286863 = _0x34bc,
                                    _0x5e8fdd = this[_0x286863(0x107)](_0x286863(0xae));
                                _0x5e8fdd !== _0x286863(0xc7) ? (_0x1b4586 = _0x5e8fdd, _0x3ccd22()) :
                                    _0xe15b1e();
                            });
                    });
                }
            });
        }
    });

    function _0xe15b1e() {
        const _0x174682 = _0x5784ea;
        _0x2ca976[_0x174682(0xbc)]()[_0x174682(0x113)](function() {
            const _0x10c260 = _0x174682;
            _0x4e681c && (_0x4e681c[_0x10c260(0xce)]['display'] = 'none'), _0x4555b && (_0x4555b[
                _0x10c260(0xce)][_0x10c260(0xaf)] = ''), _0x1504ad[_0x10c260(0x149)] = 'None';
        });
    }

    function _0x3ccd22() {
        const _0x16e954 = _0x5784ea;
        _0x2ca976['enableTextTrack'](_0x1b4586)[_0x16e954(0x113)](function(_0x51fc17) {
            const
                _0x3ac373 = _0x16e954;
            _0x4e681c && (_0x4e681c[_0x3ac373(0xce)][_0x3ac373(0xaf)] = ''), _0x4555b && (_0x4555b[
                    _0x3ac373(0xce)][_0x3ac373(0xaf)] = _0x3ac373(0xc7)), _0x1504ad['textContent'] =
                _0x321a9a(_0x1b4586);
        });
    }

    function _0x321a9a(_0x59d32a) {
        const _0x34be1a = _0x5784ea;
        if (typeof _0x59d32a !== 'string')
            return _0x59d32a;
        return _0x59d32a['charAt'](0x0)[_0x34be1a(0x17d)]() + _0x59d32a['slice'](
            0x1);
    }

    function _0x67e36f(_0x3afda7) {
        const _0x4d78bb = _0x5784ea,
            _0x7b4bfe = Math[_0x4d78bb(0xf6)](_0x3afda7 / 0x3c)[_0x4d78bb(0xc0)]()[_0x4d78bb(0xf8)](0x2,
                '0'),
            _0x5cf726 = Math[_0x4d78bb(0xf6)](_0x3afda7 % 0x3c)[_0x4d78bb(0xc0)]()[_0x4d78bb(0xf8)](0x2,
                '0');
        return _0x7b4bfe + ':' + _0x5cf726;
    }

    function _0x2f6cb3() {
        const _0x372c0d = _0x5784ea;
        _0x2e10d1 && (_0x2e10d1[_0x372c0d(0xce)][_0x372c0d(0xaf)] = 'none'), _0x1f6816 && (_0x1f6816[
                _0x372c0d(0xce)][_0x372c0d(0xaf)] = _0x372c0d(0xc7)), _0x491681 && (_0x491681[_0x372c0d(
                0xce)]['display'] = 'none', _0x491681[_0x372c0d(0xce)]['display'] = ''), _0x37ac7c && (
                _0x37ac7c[_0x372c0d(0xce)][_0x372c0d(0xaf)] = _0x372c0d(0xc7), _0x37ac7c[_0x372c0d(0xce)][
                    _0x372c0d(0xaf)
                ] = ''), _0x4bdd87 && (_0x4bdd87[_0x372c0d(0xce)][_0x372c0d(0xaf)] = _0x372c0d(0xc7)),
            _0xb4e3fe && (_0x23cabc === _0x372c0d(0x116) ? !_0x11d0c9 && (_0xb4e3fe[_0x372c0d(0xce)][
                _0x372c0d(0xaf)
            ] = _0x372c0d(0xc7), _0x11d0c9 = !![]) : _0xb4e3fe[_0x372c0d(0xce)]['display'] = _0x372c0d(
                0xc7)), _0xf5a5f8[_0x372c0d(0x12f)](_0x3a2395 => {
                const _0x409a35 = _0x372c0d;
                _0x3a2395[_0x409a35(0x146)][_0x409a35(0xa1)](_0x409a35(0xdd)), _0x3a2395[_0x409a35(0x146)]
                    [_0x409a35(0xca)](_0x409a35(0x134));
            }), _0x2b906f[_0x372c0d(0x12f)](_0x3cc692 => {
                const
                    _0x573579 = _0x372c0d;
                _0x3cc692['classList']['add'](_0x573579(0xdd)), _0x3cc692[_0x573579(0x146)][_0x573579(
                    0xa1)](_0x573579(0x134));
            });
    }

    function _0x17fac1() {
        const _0x4ceebb = _0x5784ea;
        _0x2e10d1 && (_0x2e10d1['style'][_0x4ceebb(0xaf)] = ''), _0x1f6816 && (_0x1f6816[_0x4ceebb(
                0xce)][_0x4ceebb(0xaf)] = ''), _0x491681 && (_0x491681['style'][_0x4ceebb(0xaf)] =
                _0x4ceebb(0xc7)), _0x37ac7c && (_0x37ac7c[_0x4ceebb(0xce)]['display'] = 'none'),
            _0xb4e3fe && (_0x23cabc ? !_0x11d0c9 && (_0xb4e3fe[_0x4ceebb(0xce)][_0x4ceebb(0xaf)] = '') :
                _0xb4e3fe['style'][_0x4ceebb(0xaf)] = ''), _0xf5a5f8[_0x4ceebb(0x12f)](_0x539a51 => {
                const
                    _0x4232ff = _0x4ceebb;
                _0x539a51['classList'][_0x4232ff(0xca)](_0x4232ff(0xdd)), _0x539a51[_0x4232ff(0x146)][
                    _0x4232ff(0xa1)
                ](_0x4232ff(0x134));
            }), _0x2b906f[_0x4ceebb(0x12f)](_0x39b493 => {
                const _0x419da0 =
                    _0x4ceebb;
                _0x39b493['classList'][_0x419da0(0xa1)](_0x419da0(0xdd)), _0x39b493[_0x419da0(0x146)][
                    _0x419da0(0xca)
                ]('hide');
            });
    }

    function _0x3b021c() {
        const _0x127e48 = _0x5784ea;
        pauseAllPlayers(), _0x2ca976[_0x127e48(0x14d)](), _0x2f6cb3(), currentVideo = _0x2ca976;
    }

    function _0x1527a6() {
        const _0xb3ac44 = _0x5784ea;
        _0x4a0718 = !![], _0x42dbb2(), _0x51671b[_0xb3ac44(0xce)][_0xb3ac44(0x14f)] = '0%', _0x2ca976[
            _0xb3ac44(0xad)](0x0), _0x4e41b3['textContent'] = _0xb3ac44(0x130);
    }

    function _0x42dbb2() {
        const _0x2391d4 = _0x5784ea;
        _0x2ca976[_0x2391d4(0x122)](), _0x17fac1();
    }

    function _0x1fea9d() {
        const _0x3a6eae = _0x5784ea;
        _0x2ca976[_0x3a6eae(0x151)]()[_0x3a6eae(0x113)](_0x276cc6 => {
            _0x276cc6 ? _0x3b021c() :
                _0x42dbb2();
        });
    }

    function _0x564546() {
        const _0x3fff7f = _0x5784ea;
        _0x2ca976[_0x3fff7f(0xa7)]()['then'](_0x543a37 => {
            const _0x1b5a50 = _0x3fff7f;
            _0x2ca976[_0x1b5a50(0xad)](_0x543a37 + _0x29c962);
        });
    }

    function _0x319e10() {
        const _0x48ed26 = _0x5784ea;
        _0x2ca976['getCurrentTime']()[_0x48ed26(0x113)](_0x24ad22 => {
            const _0x4942b6 = _0x48ed26;
            _0x2ca976[_0x4942b6(0xad)](_0x24ad22 - _0x4d721d);
        });
    }

    function _0x22487c(_0x320351) {
        const _0xb17318 = _0x5784ea;
        _0x4e41b3 && _0x320351['seconds'] > 0.01 && (_0x4e41b3[_0xb17318(0x149)] = _0x67e36f(_0x320351[
                _0xb17318(0xd2)] + 0x1)), _0x1de3bc = _0x320351[_0xb17318(0x129)] * 0x64 + '%', _0x51671b &&
            (_0x51671b[_0xb17318(0xce)]['width'] = _0x1de3bc);
    }

    function _0x2a1e52() {
        const _0x2d49b7 = _0x5784ea;
        _0x17fac1(), _0x4bdd87[_0x2d49b7(0xce)][_0x2d49b7(0xaf)] = '';
    }

    function _0x4f4331(_0x3fef7e) {
        const _0x140a87 = _0x5784ea,
            _0x444d75 = _0x551af9[_0x140a87(0x11e)],
            _0x3fb86b = _0x3fef7e[_0x140a87(0xbe)],
            _0x425406 = _0x3fb86b / _0x444d75 * 0x64;
        if (_0x425406 <= 0x64) {
            _0x51671b[_0x140a87(0xce)][
                _0x140a87(0x14f)
            ] = _0x425406 + '%';
            const _0x4b9f64 = _0x425406 / 0x64 * _0x9179a3;
            _0x2ca976[_0x140a87(0xad)](_0x4b9f64);
        }
    }
    _0x2ca976['on'](_0x5784ea(0x135),
        function() {
            const _0x1ec5dd = _0x5784ea;
            _0x57e1d7 && (_0x57e1d7[_0x1ec5dd(0xce)]['display'] = ''), _0x23ea03 && (_0x23ea03['style'][
                _0x1ec5dd(0xaf)
            ] = 'none');
        }), _0x2ca976['on']('bufferend', function() {
        const _0x40d982 = _0x5784ea;
        _0x57e1d7 && (_0x57e1d7[_0x40d982(0xce)]['display'] = _0x40d982(0xc7)), _0x23ea03 && (
            _0x23ea03[_0x40d982(0xce)][_0x40d982(0xaf)] = '');
    });
    if (_0x551af9) {
        function _0x193176(_0x364496) {
            const _0x2bc40a = _0x5784ea;
            _0x364496[_0x2bc40a(0xe1)](), _0x5b9cd3 = !![];
            const _0xf582de = _0x431691 ? _0x364496[
                _0x2bc40a(0x142)][0x0] : _0x364496;
            _0x4f4331(_0xf582de);
        }

        function _0x34d9bf(_0x355b9e) {
            const _0x425c83 = _0x5784ea;
            _0x355b9e['preventDefault']();
            if (_0x5b9cd3) {
                const _0x207b7e = _0x431691 ? _0x355b9e[
                    _0x425c83(0x142)][0x0] : _0x355b9e;
                _0x4f4331(_0x207b7e);
            }
        }
        _0x2ca976['on'](_0x5784ea(0x163), function(_0x14186a) {
            const
                _0x844ba1 = _0x5784ea;
            if (_0x9179a3 > 0x0) {
                const _0x32da7c = _0x14186a['seconds'] /
                    _0x14186a[_0x844ba1(0xb9)] * 0x64;
                _0x3a8488 && (_0x3a8488[_0x844ba1(0xce)][_0x844ba1(0x14f)] = _0x32da7c + '%');
            }
        });
        const
            _0xa7cef7 = () => { _0x5b9cd3 = ![]; },
            _0x431691 = _0x5784ea(0x108) in document[_0x5784ea(0x166)];
        _0x431691 ? (_0x551af9[_0x5784ea(0xd3)](_0x5784ea(0x119), _0x193176), _0x551af9[
            'addEventListener'](_0x5784ea(0xe0), _0x34d9bf), _0x551af9[_0x5784ea(0xd3)]('touchend',
            _0xa7cef7)) : (_0x551af9[_0x5784ea(0xd3)](_0x5784ea(0xe9), _0x193176), _0x56d2ea[
            'addEventListener'](_0x5784ea(0xba), _0x34d9bf), _0x56d2ea[_0x5784ea(0xd3)]('mouseup',
            _0xa7cef7));
    }

    function _0x32e585() { _0x2ca976['setCurrentTime'](0x0), _0x3b021c(); }

    function _0x3c8a28(_0x3aa21d) {
        const _0x245d63 = _0x5784ea;
        _0x2ca976['setPlaybackRate'](_0x3aa21d), _0x515412 && (Number(_0x3aa21d) === 0x1 ? _0x515412[
            _0x245d63(0x149)] = _0x245d63(0xc6) : _0x515412[_0x245d63(0x149)] = _0x3aa21d + 'x');
    }

    function _0x3511e6(_0x1c4bf3) {
        const _0x5ddc4f = _0x5784ea;
        _0x2ca976[_0x5ddc4f(0xfe)]()['then'](_0xa51bba => {
            const _0x3ae626 = _0x5ddc4f,
                _0x514fee = _0xa51bba[_0x3ae626(0x17f)](_0x25808b => {
                    return _0x25808b ===
                        _0x1c4bf3;
                });
            _0x2549a6 && (_0x2549a6[_0x3ae626(0x149)] = _0x3fc87b), _0x514fee ? _0x2ca976[_0x3ae626(
                0x141)](_0x1c4bf3)[_0x3ae626(0x113)](() => {}) : alert(_0x3ae626(0x112));
        });
    }

    function _0x4d5ad2() {
        const _0x50cb4d = _0x5784ea;
        _0xd1051 && (_0x2ca976[_0x50cb4d(0xf0)](_0xd1051[_0x50cb4d(0x100)]), _0x2ca976[_0x50cb4d(0x110)]
            ()[_0x50cb4d(0x113)](_0x1a2c1e => {
                const _0x39e34c = _0x50cb4d;
                _0x1a2c1e < 0.01 ? _0x2832aa['style']['opacity'] = 0.5 : (_0x51f8c2 = _0x1a2c1e,
                    _0x2832aa[_0x39e34c(0xce)]['opacity'] = 0x1);
            }));
    }

    function _0x91d3f6() {
        const _0x34e9c4 = _0x5784ea;
        _0xd1051[_0x34e9c4(0x100)] > 0x0 ? (_0x51f8c2 = _0xd1051[_0x34e9c4(0x100)], _0x2ca976[_0x34e9c4(
                0xf0)](0x0), _0xd1051[_0x34e9c4(0x100)] = 0x0, _0x2832aa['style'][_0x34e9c4(0xde)] = 0.5) :
            (_0x2ca976[_0x34e9c4(0xf0)](_0x51f8c2), _0xd1051[_0x34e9c4(0x100)] = _0x51f8c2, _0x2832aa[
                'style']['opacity'] = 0x1);
    }

    function _0x4302a6() {
        const _0x3d5269 = _0x5784ea;
        _0x2ca976[_0x3d5269(0x138)]()[_0x3d5269(0x113)](_0x3f7e6f => {
            const _0xd5cf37 = _0x3d5269;
            _0x3f7e6f ? _0x2ca976['exitFullscreen']() : _0x2ca976[_0xd5cf37(0x162)]();
        });
    }

    function _0x20f79d() {
        const _0x235d06 = _0x5784ea;
        _0x2ca976[_0x235d06(0xdc)]()['then'](_0x55965e => {
            const _0x33c94c = _0x235d06;
            _0x2ca976[_0x33c94c(0x167)](_0x55965e);
        });
    }

    function _0x55df9d(_0x2fbf4c) {
        const _0x4a0e33 = _0x5784ea;
        if (_0x223f88) {
            const _0x4daa1f =
                _0x2fbf4c[_0x4a0e33(0x136)];
            (_0x4daa1f === '\x20' || _0x4daa1f === 'ArrowDown' || _0x4daa1f === _0x4a0e33(0xc4)) &&
            _0x2fbf4c[_0x4a0e33(0xe1)]();
            if (currentVideo === _0x2ca976) switch (_0x4daa1f) {
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    const _0x452d13 = parseInt(_0x4daa1f) * 0xa,
                        _0x4f08b4 = _0x452d13 / 0x64 * _0x9179a3;
                    _0x2ca976[_0x4a0e33(0xad)](_0x4f08b4);
                    break;
                case '\x20':
                case 'k':
                    _0x2ca976[_0x4a0e33(0x151)]()[_0x4a0e33(0x113)](_0x21a83b => {
                        _0x21a83b ? _0x3b021c() :
                            _0x42dbb2();
                    });
                    break;
                case _0x4a0e33(0xb3):
                    _0x319e10();
                    break;
                case _0x4a0e33(0x121):
                    _0x564546();
                    break;
                case _0x4a0e33(0xc4):
                    _0xd1051 && (_0xd1051[_0x4a0e33(0x100)] = Number(_0xd1051[_0x4a0e33(0x100)]) + 0.1,
                        _0x4d5ad2());
                    break;
                case _0x4a0e33(0xdf):
                    _0xd1051 && (_0xd1051['value'] = _0xd1051[_0x4a0e33(0x100)] - 0.1, _0x4d5ad2());
                    break;
                case 'm':
                    _0x91d3f6();
                    break;
                case 'f':
                    _0x4302a6();
                    break;
                case 'l':
                    _0x20f79d();
                    break;
                default:
                    break;
            }
        }
    }
    _0x4e681c && _0x4e681c[_0x5784ea(0xd3)](_0x5784ea(0xd4), _0xe15b1e),
        _0x4555b && _0x4555b[_0x5784ea(0xd3)](_0x5784ea(0xd4), _0x3ccd22), _0x23ea03 && _0x23ea03[
            _0x5784ea(0xd3)](_0x5784ea(0xd4), _0x1fea9d), _0x2e10d1 && _0x2e10d1[_0x5784ea(0xd3)]('click',
            _0x3b021c), _0x37ac7c && _0x37ac7c[_0x5784ea(0xd3)](_0x5784ea(0xd4), _0x42dbb2), _0x2d9511 &&
        _0x2d9511['addEventListener'](_0x5784ea(0xd4), _0x1527a6), _0x586138 && _0x586138[_0x5784ea(
            0xd3)](_0x5784ea(0xd4), _0x564546), _0x4b72c9 && _0x4b72c9[_0x5784ea(0xd3)]('click',
            _0x319e10), _0x551af9 && _0x551af9['addEventListener']('click', _0x4f4331), _0xd1051 && (
            _0xd1051[_0x5784ea(0xd3)](_0x5784ea(0x175), _0x4d5ad2), _0xd1051[_0x5784ea(0xd3)](_0x5784ea(
                0x119), _0x4d5ad2)), _0x4bdd87 && _0x4bdd87[_0x5784ea(0xd3)](_0x5784ea(0xd4), _0x32e585),
        _0x2832aa && _0x2832aa['addEventListener']('click', _0x91d3f6), _0x583020 && _0x583020[
            _0x5784ea(0xd3)](_0x5784ea(0xd4), _0x4302a6), _0x1ee07b && _0x1ee07b['forEach'](function(
            _0x5ef26f) {
            const _0x5f02a8 = _0x5784ea;
            _0x5ef26f[_0x5f02a8(0xd3)](_0x5f02a8(0xd4), function() {
                const _0x5b7180 = _0x5f02a8;
                _0x2afeab = this[_0x5b7180(0x107)]('f-data-video-speed'), _0x3c8a28(_0x2afeab);
            });
        }),
        _0x327715 && _0x327715[_0x5784ea(0x12f)](function(_0x105896) {
            const _0x39b1aa = _0x5784ea;
            _0x105896[_0x39b1aa(0xd3)](_0x39b1aa(0xd4), function() {
                const _0x31dc64 = _0x39b1aa;
                _0x3fc87b = this[_0x31dc64(0x107)](_0x31dc64(0xeb)), _0x3511e6(_0x3fc87b);
            });
        }), document[
            _0x5784ea(0xd3)]('keydown', _0x55df9d), _0x2ca976['on'](_0x5784ea(0xb5), _0x22487c),
        _0x2ca976['on'](_0x5784ea(0x13a), _0x2a1e52), _0x2ca976['on'](_0x5784ea(0x11f),
            function() {
                const _0x59e4e8 = _0x5784ea,
                    _0x3b4adc = $(_0x59e4e8(0xd7))['find'](_0x59e4e8(0x114));
                _0xcc6908 && _0x3b4adc['addClass'](_0xcc6908['getAttribute']('class'));
            }), _0x11173c();
}
const Vvideos = document[_0x13003e(0xb7)](_0x13003e(0xd7));
vimeoScript['onload'] = function() {
    const _0x3908d9 = _0x13003e;
    Vvideos[_0x3908d9(0x12b)] > 0x0 && Vvideos[_0x3908d9(0x12f)](
        _0x2cfa42 => { initializeVimeoPlayer(_0x2cfa42); });
};

function updateCounter(_0x3ddc08) {
    const _0x34416c = _0x13003e;
    var _0x4d05c0 = new Date(),
        _0x243d7a = _0x4d05c0['getMonth'](),
        _0x3ad31d = btoa('flowplaycounter'),
        _0x2a8e15 = btoa(_0x243d7a[_0x34416c(0xc0)]()),
        _0x994fb2 = getCookie(_0x3ad31d);
    !_0x994fb2 || _0x994fb2 !== _0x2a8e15 ? $[_0x34416c(0x125)](
        _0x34416c(0x15d),
        function(_0x5b787b) {
            const _0x24dc3a = _0x34416c;
            console[_0x24dc3a(0x164)](_0x5b787b), document['cookie'] = _0x3ad31d + '=' + _0x2a8e15;
        })[
        _0x34416c(0x133)](function(_0x2ab211, _0x45946b, _0x3c95b5) {
        const _0x297236 = _0x34416c;
        console[_0x297236(0xda)](_0x297236(0xa3), _0x3c95b5);
    }) : console[_0x34416c(0x164)](
        'Counter\x20already\x20updated\x20for\x20this\x20month.');
}

function getCookie(_0xb0484e) {
    const _0x1daa18 = _0x13003e;
    var _0x3dda61 = null;
    if (document[
            _0x1daa18(0xa4)] && document[_0x1daa18(0xa4)] !== '') {
        var _0x53527a = document['cookie'][
            _0x1daa18(0xb0)
        ](';');
        for (var _0x54660b = 0x0; _0x54660b < _0x53527a[_0x1daa18(0x12b)]; _0x54660b++) {
            var
                _0x4fbe59 = _0x53527a[_0x54660b]['trim']();
            if (_0x4fbe59[_0x1daa18(0xd8)](0x0, _0xb0484e[
                    _0x1daa18(0x12b)] + 0x1) === _0xb0484e + '=') {
                _0x3dda61 = decodeURIComponent(_0x4fbe59[
                    _0x1daa18(0xd8)](_0xb0484e['length'] +
                    0x1));
                break;
            }
        }
    }
    return _0x3dda61;
}
updateCounter();